
window.addEventListener("load", () => {
    if (typeof window.iconSyncHeaderHeightVars === 'function') {
        window.iconSyncHeaderHeightVars();
    }
    rafRefreshST();
});
const videos = document.querySelectorAll('video[data-src]');
const config = {
    rootMargin: '500px 0px',
    threshold: 0.01
};

const loadVideo = (video) => {
    const source = document.createElement('source');
    source.src = video.getAttribute('data-src');
    source.type = 'video/mp4';
    // Refresh ScrollTrigger after metadata loads to avoid layout shift
    video.addEventListener('loadedmetadata', rafRefreshST, { once: true });
    video.addEventListener('error', rafRefreshST, { once: true });
    video.appendChild(source);
    video.load();
    video.removeAttribute('data-src');
};

const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadVideo(entry.target);
        obs.unobserve(entry.target);
      }
    });
}, config);

videos.forEach(video => {
    observer.observe(video);
});

const mm = gsap.matchMedia();

jQuery(function($){
    if (typeof window.iconInitHeaderHeightVars === 'function') {
        window.iconInitHeaderHeightVars();
    }

    ScrollTrigger.config({
        ignoreMobileResize: true,
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
    });

    var dropdown = $('.custom-select');
    if(dropdown.length){
        initDropdown('custom-select');
    }

    document.addEventListener("click", closeAllSelect);

    //Stops scroll on menu open
    $('#mainNavigation').on('show.bs.collapse', function () {
        stopScroll();
    });

    //Resumes scroll on menu close
    $('#mainNavigation').on('hide.bs.collapse', function () {
        resumeScroll();
    });

    const desktopNavigationQuery = window.matchMedia("(min-width: 1200px)");
    const unlockMenuOnDesktop = (event) => {
        if (!event.matches) return;

        const mainNavigation = document.getElementById("mainNavigation");
        if (!mainNavigation) return;

        if (mainNavigation.classList.contains("show") && typeof bootstrap !== "undefined" && bootstrap.Collapse) {
            bootstrap.Collapse.getOrCreateInstance(mainNavigation, { toggle: false }).hide();
        }

        requestAnimationFrame(() => {
            if (isScrollLocked) {
                resumeScroll();
            }
        });
    };

    if (desktopNavigationQuery.addEventListener) {
        desktopNavigationQuery.addEventListener("change", unlockMenuOnDesktop);
    } else {
        desktopNavigationQuery.addListener(unlockMenuOnDesktop);
    }
    unlockMenuOnDesktop(desktopNavigationQuery);

    window.addEventListener("resize", preserveScrollOnResize, { passive: true });
    initSinglePostToc();
    initNativeShareButtons();

    var parallaxCards = $('.module--parallax-cards');
    if(parallaxCards.length){
        var pin = parallaxCards.find('.static-bg');

        ScrollTrigger.create({
            trigger: parallaxCards,
            start: () => "top top+=" + getTop(),
            end: "bottom bottom",
            pin: pin,
            pinSpacing: false,
            invalidateOnRefresh: true,
            markers: false,
        });

        // refresh once after creation
        rafRefreshST();

        // refresh when media inside finishes loading (images/videos/posters)
        refreshOnMedia(parallaxCards[0]);

        // refresh if the module size changes (layout shifts, fonts, etc.)
        observeParallaxResize(parallaxCards[0]);

        // refresh on maximize/restore/minimize-return
        bindWindowStateRefresh();

    }

    var testimonials = $('.testimonials');
    if (testimonials.length) {
        var testimonialsSwiper;
        var testimonialsChildren = $(testimonials).children();
        var testimonialSlide = '.testimonial';
        var testimonialsPagination = $('.module--testimonials .swiper-pagination');
        var isSwiperInitialized = false;
        var testimonialsScrollTriggers = []; // Track only testimonials triggers
        var testimonialsTween;
        var testimonialsTransElements = [];
        var testimonialsScrollId = "testimonials-scroll";

        function killTestimonialsScrollTriggers() {
            var existing = ScrollTrigger.getById(testimonialsScrollId);
            if (existing) {
                existing.kill(true);
            }
            ScrollTrigger.getAll().forEach(function (trigger) {
                if (trigger && trigger.trigger) {
                    var el = trigger.trigger;
                    if (typeof el.closest === "function") {
                        if (el.closest(".module--testimonials")) {
                            trigger.kill(true);
                        }
                    } else if (el === document.querySelector(".module--testimonials")) {
                        trigger.kill(true);
                    }
                }
            });
            testimonialsScrollTriggers.forEach(trigger => trigger.kill());
            testimonialsScrollTriggers = [];
            if (testimonialsTween) {
                testimonialsTween.kill();
                testimonialsTween = null;
            }
            if (testimonialsTransElements.length) {
                gsap.set(testimonialsTransElements, { clearProps: "transform,willChange" });
                testimonialsTransElements = [];
            }
        }
        
        mm.add("(max-width: 991px)", () => {  
            // Clean up any desktop scroll triggers when entering mobile
            killTestimonialsScrollTriggers();
            
            // Initialize Swiper if not already initialized
            if (!isSwiperInitialized) {
                initSwiper(testimonials, testimonialsChildren, testimonialSlide);
                var params = SwiperCarouselParams(false, 0, false, '', '', 1, 1, 1, 1, testimonialsPagination[0], '');
                testimonialsSwiper = new Swiper(testimonials[0], params);
                isSwiperInitialized = true;
            }
            return () => {
                requestAnimationFrame(() => {
                    ScrollTrigger.refresh();
                });
            };
        });
        
        mm.add("(min-width: 992px)", () => {
            const module = document.querySelector(".module--testimonials");
            const transElements = Array.from(module ? module.querySelectorAll(".trans") : []);
            if (!module || !transElements.length) return;

            killTestimonialsScrollTriggers();
            testimonialsTransElements = transElements;
            
            // Destroy Swiper if it's initialized
            if (isSwiperInitialized) {
                destroySwiper(testimonialsSwiper, testimonials, testimonialsChildren, testimonialSlide);
                isSwiperInitialized = false; // Reset the flag
            }

            let viewportHeight = 0;
            let totalHeight = 0;
            let startY = 0;
            let endY = 0;
            let topOffset = 0;

            const measure = () => {
                // Clear transforms for accurate measurements
                gsap.set(transElements, { y: 0 });

                topOffset = getTop();
                viewportHeight = window.innerHeight - topOffset;
                const firstRect = transElements[0].getBoundingClientRect();
                const lastRect = transElements[transElements.length - 1].getBoundingClientRect();
                totalHeight = lastRect.bottom - firstRect.top;

                startY = viewportHeight - totalHeight;
                endY = -viewportHeight + totalHeight;
                gsap.set(transElements, { y: startY, willChange: "transform" });
            };

            // Initial measurement
            measure();

            testimonialsTween = gsap.to(transElements, {
                y: () => -viewportHeight + totalHeight,
                ease: "none",
                overwrite: "auto",
                scrollTrigger: {
                    id: testimonialsScrollId,
                    trigger: module,
                    start: () => `top-=${topOffset}px top`,
                    end: "bottom bottom",
                    scrub: true,
                    invalidateOnRefresh: true,
                    onUpdate: self => {
                        const y = startY + (endY - startY) * self.progress;
                        gsap.set(transElements, { y });
                    },
                    onRefreshInit: () => measure(),
                    onRefresh: (self) => {
                        const y = startY + (endY - startY) * self.progress;
                        gsap.set(transElements, { y });
                    },
                    markers: false,
                    onLeave: () => module.classList.add("overflow-hidden"),
                    onEnterBack: () => module.classList.remove("overflow-hidden"),
                }
            });
            if (testimonialsTween.scrollTrigger) {
                testimonialsScrollTriggers.push(testimonialsTween.scrollTrigger);
            }

            
            return () => {
                killTestimonialsScrollTriggers();
                requestAnimationFrame(() => {
                    ScrollTrigger.refresh();
                });
            };
        });
    }

    var headerImg = $('.anim-img');
    if(headerImg.length){
        var widgets = $('.widgets');
        ScrollTrigger.create({
            trigger: headerImg,
            start: () => "top top+=" + getTop(),
            endTrigger: widgets.length ? widgets : headerImg,
            end: () => widgets.length ? "top top" : "+=" + window.innerHeight,
            pin: headerImg,
            pinSpacing: false,
            invalidateOnRefresh: true,
            markers: false
        });
    }

    var authorShareSection = $('.author-share-section');
    if(authorShareSection.length){
        const createAuthorSharePin = () => {
            const section = document.querySelector('.author-share-section');
            const pin = document.querySelector('.author-share');
            const desktopQuery = window.matchMedia("(min-width: 992px)");
            let isActive = true;

            if (!section || !pin) return null;

            const stopGapAttr = section.getAttribute('data-author-share-stop-gap');
            const stopGapValue = parseFloat(stopGapAttr);
            const stopGap = stopGapAttr !== null && !isNaN(stopGapValue) ? Math.max(0, stopGapValue) : 80;

            const clearPinStyles = () => {
                pin.style.position = '';
                pin.style.top = '';
                pin.style.left = '';
                pin.style.width = '';
                pin.style.zIndex = '';
                pin.style.transform = '';
                pin.style.willChange = '';
            };

            const updatePinPosition = () => {
                if (!isActive || !desktopQuery.matches) {
                    clearPinStyles();
                    return;
                }

                const offset = getTop() + 24;
                const scrollY = getCurrentScrollY();
                const sectionTop = section.getBoundingClientRect().top + scrollY;
                const maxY = Math.max(0, section.offsetHeight - pin.offsetHeight - stopGap);
                const currentY = Math.max(0, Math.min(maxY, scrollY + offset - sectionTop));

                if (currentY <= 0) {
                    clearPinStyles();
                    return;
                }

                pin.style.position = '';
                pin.style.top = '';
                pin.style.left = '';
                pin.style.width = '';
                pin.style.zIndex = '';
                pin.style.transform = 'translate3d(0, ' + currentY + 'px, 0)';
                pin.style.willChange = 'transform';
            };

            const requestPinUpdate = () => {
                requestAnimationFrame(() => {
                    if (!isActive) return;
                    updatePinPosition();
                });
            };

            const trigger = ScrollTrigger.create({
                trigger: section,
                start: () => "top top+=" + (getTop() + 24),
                end: () => "+=" + Math.max(0, section.offsetHeight - pin.offsetHeight - stopGap),
                onRefreshInit: clearPinStyles,
                onEnter: updatePinPosition,
                onUpdate: updatePinPosition,
                onRefresh: updatePinPosition,
                onLeave: updatePinPosition,
                onEnterBack: updatePinPosition,
                onLeaveBack: updatePinPosition,
                invalidateOnRefresh: true,
                markers: false,
            });

            window.addEventListener('resize', requestPinUpdate, { passive: true });
            requestPinUpdate();

            return {
                kill: () => {
                    isActive = false;
                    trigger.kill();
                    window.removeEventListener('resize', requestPinUpdate);
                    clearPinStyles();
                }
            };
        };

        mm.add("(min-width: 992px)", () => {
            const trigger = createAuthorSharePin();
            return () => {
                if (trigger) trigger.kill();
                ScrollTrigger.refresh();
            };
        });
    }

    var filters = $('.filters');
    var tagIds = [];

    if (filters.length) {
        var vibes = filters.find('.tag');
        if (vibes.length) {
            vibes.on('click', function () {
                $(this).toggleClass('active');
                if($(this).hasClass('all')){
                    vibes.not($(this)).removeClass('active');
                }
                if(!$(this).hasClass('all')){
                    $('.filters .all').removeClass('active');
                }

                tagIds = getVibes();
                locationIds = getLocations();

                programFilters(tagIds, locationIds);
            });
        }
    }

    location = $('.location-select');
    if(location.length){
        location.on('change', function(){
            tagIds = getVibes();
            locationIds = getLocations();
            programFilters(tagIds, locationIds);
        });
    }



    var programs = $('.module--programs');
    if(programs.length){
        var programsTitle = programs[0].querySelector('.programs-title');
        var programsBlurResetToken = 0;

        const setProgramsBlurred = (shouldBlur, immediate = false) => {
            if (!programsTitle) return;

            if (immediate) {
                const resetToken = ++programsBlurResetToken;
                programsTitle.classList.add('is-resetting-blur');
                programsTitle.classList.toggle('blured', shouldBlur);

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        if (resetToken === programsBlurResetToken) {
                            programsTitle.classList.remove('is-resetting-blur');
                        }
                    });
                });
                return;
            }

            programsTitle.classList.toggle('blured', shouldBlur);
        };

        ScrollTrigger.create({
            id: "programs-showcase",
            trigger: programsTitle,
            start: () => "top top+=" + getSectionDistance(),
            endTrigger: programs[0],
            end: () => "bottom bottom",
            pin: programsTitle,
            pinSpacing: false,
            invalidateOnRefresh: true,
            markers: false,
            onEnter: () => setProgramsBlurred(true),
            onLeave: () => setProgramsBlurred(true),
            onEnterBack: () => setProgramsBlurred(true),
            onLeaveBack: () => setProgramsBlurred(false, true),
            onRefreshInit: () => {
                programsTitle.classList.add('is-resetting-blur');
            },
            onRefresh: (self) => {
                // Refresh can skip enter/leave callbacks. Reapply the visual state
                // from the refreshed progress and avoid animating through a partial
                // blur while the pin is being measured/repositioned.
                setProgramsBlurred(self.isActive || self.progress > 0, true);
            },
        });

        // The pin start depends on everything stacked above the module, so keep it
        // in sync when lazy media above it loads and shifts the page height during
        // the initial settle (the observer debounces and auto-disconnects after).
        observeDocumentHeightForRefresh();
    }

    var prefooterCarousel = $('.module-prefooter-gallery .prefooter-gallery');
    if(prefooterCarousel.length){
        var prefooterCarouselSwiper;
        var prefooterCarouselChildren = $(prefooterCarousel).children();
        var prefooterCarouselSlide = '.gallery-img';
        var prefooterCarouselPagination = $('.module-prefooter-gallery .swiper-pagination');

        initSwiper(prefooterCarousel, prefooterCarouselChildren, prefooterCarouselSlide);
        //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
        var prefooterCarouselParams = SwiperCarouselParams(false, 0, false, '', '', 2, 2, 4, 5, prefooterCarouselPagination[0], '');
        prefooterCarouselSwiper = new Swiper(prefooterCarousel[0], prefooterCarouselParams);
    }

    var moduleLocationShowcase = $('.module--location-showcase');
    if(moduleLocationShowcase.length){
        var img = moduleLocationShowcase.find('.dynamic-img');
        var imgSource = moduleLocationShowcase.find('.dynamic-img-source');
        var location = moduleLocationShowcase.find('.location-title');
        mm.add("(min-width: 992px)", () => {
        // remove any previous handlers for safety, then add fresh ones
        location.off(".locShowcase");

        location.on("mouseenter.locShowcase", function () {
            const imgUrl = $(this).data("img");
            img.attr("src", imgUrl);
            imgSource.attr("srcset", imgUrl);
            moduleLocationShowcase.addClass("active");
            location.not(this).addClass("disabled");
        });

        location.on("mouseleave.locShowcase", function () {
            moduleLocationShowcase.removeClass("active");
            location.not(this).removeClass("disabled");
        });

        // IMPORTANT: cleanup runs when leaving the breakpoint
        return () => {
            location.off(".locShowcase");                 // remove handlers
            moduleLocationShowcase.removeClass("active"); // reset state
            location.removeClass("disabled");             // reset state
        };
        });
        
    }

    var animatedCards = $('.module--animated-cards');
    if(animatedCards.length){
        mm.add("(min-width: 992px)", () => {
            gsap.utils.toArray(".module--animated-cards .animated-card-col").forEach(col => {
                gsap.to(col, {
                    rotate: 0,
                    scrollTrigger: {
                        trigger: col,
                        start: "top 50%",  // trigger when col is 80% into the viewport
                        toggleActions: "play none none none",
                        markers: false,
                    }
                });
            });
            return () => {}
        });
    }

    var video = $('video');
    if(video.length){
        var videoParent = video.parent();
        if(videoParent.length){
            var playBtn = videoParent.find('.play');
            var soundBtn = videoParent.find('.sound');

            playBtn.on('click', function(){
                if(!video[0].paused){
                    video[0].pause();
                    playBtn.find('i').removeClass('icon-pause');
                    playBtn.find('i').addClass('icon-play');
                }else{
                    video[0].play();
                    playBtn.find('i').removeClass('icon-play');
                    playBtn.find('i').addClass('icon-pause');
                }
            });
            soundBtn.on('click', function(){
                if(video[0].muted){
                    video[0].muted = false;
                    soundBtn.find('i').removeClass('icon-unmute');
                    soundBtn.find('i').addClass('icon-mute');
                }else{
                    video[0].muted = true;
                    soundBtn.find('i').removeClass('icon-mute');
                    soundBtn.find('i').addClass('icon-unmute');
                }
            });
        }
    }

    var basicCarouselModule = $('.module--basic-carousel');
    if(basicCarouselModule.length){
        var basicCarouselSwiper;
        var basicCarousel = basicCarouselModule.find('.basic-carousel');
        var basicCarouselChildren = basicCarousel.children();
        var basicCarouselSlide = basicCarousel.find('.slide');
        var basicCarouselNext = basicCarouselModule.find('.carousel-next');
        var basicCarouselPrev = basicCarouselModule.find('.carousel-prev');
        initSwiper(basicCarousel, basicCarouselChildren, basicCarouselSlide);
        //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
        var basicCarouselParams = SwiperCarouselParams(false, 24, false, basicCarouselNext[0], basicCarouselPrev[0], 1.2, 2.2, 3.2, 3.2, '', '');
        basicCarouselSwiper = new Swiper(basicCarousel[0], basicCarouselParams);
    }

    var articleSliderModule = $('.module--article-slider');
    if(articleSliderModule.length){
        articleSliderModule.each(function(){
            var articleSliderModuleItem = $(this);
            var articleSlider = articleSliderModuleItem.find('.article-slider');
            var articleSliderChildren = articleSlider.children();
            var articleSliderSlide = articleSlider.find('.slide');
            var articleSliderNext = articleSliderModuleItem.find('.carousel-next');
            var articleSliderPrev = articleSliderModuleItem.find('.carousel-prev');

            if(articleSliderChildren.length){
                initSwiper(articleSlider, articleSliderChildren, articleSliderSlide);
                //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
                var articleSliderParams = SwiperCarouselParams(false, 16, false, articleSliderNext[0], articleSliderPrev[0], 1, 1, 2.2, 2.2, '', '');
                new Swiper(articleSlider[0], articleSliderParams);
            }
        });
    }

    var latestNewsModule = $('.module--latest-news');
    if(latestNewsModule.length){
        latestNewsModule.each(function(){
            var latestNewsModuleItem = $(this);
            var latestNewsSlider = latestNewsModuleItem.find('.latest-news__slider');
            var latestNewsPagination = latestNewsModuleItem.find('.latest-news__pagination');
            var latestNewsNext = latestNewsModuleItem.find('.carousel-next');
            var latestNewsPrev = latestNewsModuleItem.find('.carousel-prev');

            if(latestNewsSlider.length && latestNewsSlider.find('.swiper-slide').length){
                //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
                var latestNewsParams = SwiperCarouselParams(false, 16, false, latestNewsNext[0], latestNewsPrev[0], 1, 2, 3, 3, latestNewsPagination[0], '');
                new Swiper(latestNewsSlider[0], latestNewsParams);
            }
        });
    }

    var featuredArticlesModule = $('.module--featured-articles');
    if(featuredArticlesModule.length){
        featuredArticlesModule.each(function(){
            var featuredArticlesModuleItem = $(this);
            var featuredArticlesSlider = featuredArticlesModuleItem.find('.featured-articles__slider');
            var featuredArticlesPagination = featuredArticlesModuleItem.find('.featured-articles__pagination');
            var featuredArticlesNext = featuredArticlesModuleItem.find('.carousel-next');
            var featuredArticlesPrev = featuredArticlesModuleItem.find('.carousel-prev');

            if(featuredArticlesSlider.length && featuredArticlesSlider.find('.swiper-slide').length){
                //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
                var featuredArticlesParams = SwiperCarouselParams(false, 16, false, featuredArticlesNext[0], featuredArticlesPrev[0], 1, 2, 3, 3, featuredArticlesPagination[0], '');
                new Swiper(featuredArticlesSlider[0], featuredArticlesParams);
            }
        });
    }

    var testimonialSliderModule = $('.module--testimonial-slider');
    if(testimonialSliderModule.length){
        var testimonialSliderSwiper;
        var testimonialSlider = testimonialSliderModule.find('.testimonial-slider');
        var testimonialSliderChildren = testimonialSlider.children();
        var testimonialSliderSlide = testimonialSlider.find('.slide');
        var testimonialSliderNext = testimonialSliderModule.find('.carousel-next');
        var testimonialSliderPrev = testimonialSliderModule.find('.carousel-prev');
        initSwiper(testimonialSlider, testimonialSliderChildren, testimonialSliderSlide);
        //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
        var testimonialSliderParams = SwiperCarouselParams(false, 16, false, testimonialSliderNext[0], testimonialSliderPrev[0], 1, 2, 2, 2, '', '');
        testimonialSliderSwiper = new Swiper(testimonialSlider[0], testimonialSliderParams);
    }

    var slideFadeCarouselModule = $('.module--slide-fade-carousel');
    if(slideFadeCarouselModule.length){
        var slideFadeCarouselSwiper;
        var slideFadeCarousel = slideFadeCarouselModule.find('.slide-fade-carousel');
        var slideFadeCarouselChildren = slideFadeCarousel.children();
        var slideFadeCarouselSlide = slideFadeCarousel.find('.slide');
        var activeFade = $('.fade-slide.active');
        var slideFadeCarouselNext = slideFadeCarouselModule.find('.carousel-next');
        var slideFadeCarouselPrev = slideFadeCarouselModule.find('.carousel-prev');
        initSwiper(slideFadeCarousel, slideFadeCarouselChildren, slideFadeCarouselSlide);
        //(center, spacing, isLoop, nextbtn, prevBtn, slidesToShowSm, slidesToShowMd, slidesToShowLg, slidesToShoXl, Bullets, effect)
        var slideFadeCarouselParams = SwiperCarouselParams(false, 0, false, slideFadeCarouselNext[0], slideFadeCarouselPrev[0], 1, 1, 1, 1, '', '');
        slideFadeCarouselSwiper = new Swiper(slideFadeCarousel[0], slideFadeCarouselParams);
        
        slideFadeCarouselSwiper.on('slideChange', function () {
            activeFade.removeClass('active');
            activeFade = $('.fade-slide').eq(this.realIndex).addClass('active');
            activeFade = $('.fade-slide.active');
        });
    }

    var scrollCarousel = $('.module--scroll-carousel');
    if(scrollCarousel.length){
        mm.add("(min-width: 992px)", () => {
            var slides = gsap.utils.toArray(".module--scroll-carousel .scroll-carousel-slide");
            const images = gsap.utils.toArray(".module--scroll-carousel .scroll-carousel-img img");
            var pin =  gsap.utils.toArray(".module--scroll-carousel .scroll-carousel-img" );

            images.forEach((image, i) => {
                if(i > 0){
                    gsap.set(image, {yPercent:101});
                }
            });

            ScrollTrigger.create({
                trigger: scrollCarousel,
                start: () => "top top",
                end: () => "bottom bottom",
                pin: pin,
                invalidateOnRefresh: true,
                anticipatePin: 1,
                scrub: true,
                pinSpacing: false,
                markers: false
            })

            slides.forEach((slide, i)=> {
                if (!images[i]) return;
                gsap.to(images[i], {
                    yPercent: 0,
                    ease: "none",
                    scrollTrigger: {
                        trigger: slide,
                        start: () => "top bottom",
                        end: () => "bottom bottom",
                        scrub: true,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                });
            })
            return () => {}
        })
    }

    var formBtn = $('.form-btn');
    if(formBtn){
        formBtn.on('click', function(){
            var submit = $(this).parent().find('input'); 
            submit.trigger('click');
        });
    }

});

//lenis init
const lenis = new Lenis({
    duration: 1.5,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
    syncTouch: false,
});
lenis.on('scroll', ScrollTrigger.update);
gsap.ticker.add((time)=>{
    lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);


function SwiperCarouselParams(center, spacing, isLoop, next, prev, slidesToShowSm, slidesMd, slidesLg, slidesXl, pagination, effect){
    return{
        slidesPerView: slidesToShowSm,
        grabCursor: true,
        watchSlidesVisibility: true,
        centeredSlides: center,
        spaceBetween: spacing,
        loop: isLoop,
        effect: effect,
        coverflowEffect: {
            rotate: 0,
            stretch: 10,
            depth: 160,
            slideShadows: false,
            modifier: 4,
        },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
        breakpoints: {
            768: {
                spaceBetween: spacing,
                slidesPerView: slidesMd,
            },
            991: {
                spaceBetween: spacing,
                slidesPerView: slidesLg,
            },
            1200: {
                spaceBetween: spacing,
                slidesPerView: slidesXl,
            }
        }
    }
}

function initSwiper(elem, children, slide){
    $(elem).addClass("swiper");
    if (!$(elem).children('.swiper-wrapper').length) {
        children.wrapAll('<div class="swiper-wrapper"></div>');
    }
    $(elem).find(slide).addClass('swiper-slide');
}

function destroySwiper(swiper, elem, children, slide){
    if ( swiper !== undefined ){
        swiper.destroy(true, true);
    }
    $(elem).removeClass('swiper');
    children.unwrap();
    $(elem).find(slide).removeClass('swiper-slide');
}

function getTop() {
    const root = document.documentElement;
    const body = document.body;

    const headerHeight = parseFloat(getComputedStyle(body).getPropertyValue('--header-height')) || parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
    const adminBarHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--wp-admin--admin-bar--height')) || 0;

    return headerHeight + adminBarHeight;
}

function getSectionDistance() {
    // NOTE: this runs on every ScrollTrigger refresh (used in the pin `start`),
    // so it must be a pure, synchronous calculation. Do NOT register gsap.matchMedia
    // contexts here — they accumulate on every call and fire in unpredictable order
    // when crossing the breakpoint during a resize, which left the pin start value
    // inconsistent (title pinned at the wrong position / jumping on scroll).
    var isDesktop = window.matchMedia("(min-width: 992px)").matches;
    return getTop() + (isDesktop ? 200 : 80);
}

function initNativeShareButtons() {
    const shareButtons = document.querySelectorAll('[data-native-share]');
    if (!shareButtons.length) return;

    shareButtons.forEach((button) => {
        if (button.dataset.nativeShareBound === 'true') return;
        button.dataset.nativeShareBound = 'true';

        button.addEventListener('click', () => {
            const shareData = {
                title: button.getAttribute('data-share-title') || document.title,
                text: button.getAttribute('data-share-text') || '',
                url: button.getAttribute('data-share-url') || window.location.href
            };

            if (navigator.share) {
                navigator.share(shareData).catch(() => {});
                return;
            }

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(shareData.url).catch(() => {});
                return;
            }

            const input = document.createElement('input');
            input.value = shareData.url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        });
    });
}

function initSinglePostToc() {
    const tocLinks = document.querySelectorAll('.single-post-toc__link[href^="#"]');
    if (!tocLinks.length) return;

    const getTarget = (hash) => {
        const rawId = hash.slice(1);
        if (!rawId) return null;

        const rawTarget = document.getElementById(rawId);
        if (rawTarget) return rawTarget;

        try {
            return document.getElementById(decodeURIComponent(rawId));
        } catch (error) {
            return null;
        }
    };

    const scrollToTarget = (hash, updateUrl = true) => {
        const target = getTarget(hash);
        if (!target) return false;

        clearResizeScrollState();

        if (typeof lenis !== "undefined" && typeof lenis.resize === "function") {
            lenis.resize();
        }

        if (typeof ScrollTrigger !== "undefined" && typeof ScrollTrigger.refresh === "function") {
            ScrollTrigger.refresh();
        }

        const targetY = target.getBoundingClientRect().top + getCurrentScrollY() - getTop() - 24;
        const scrollY = clampScrollY(targetY);

        if (typeof lenis !== "undefined" && typeof lenis.scrollTo === "function") {
            lenis.scrollTo(scrollY, { force: true });
        } else {
            window.scrollTo({ top: scrollY, behavior: "smooth" });
        }

        if (updateUrl && window.history && window.history.pushState) {
            window.history.pushState(null, '', hash);
        }

        return true;
    };

    tocLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
            const hash = link.getAttribute('href');
            if (!hash || hash === '#') return;

            if (scrollToTarget(hash)) {
                event.preventDefault();
            }
        });
    });

    if (window.location.hash && Array.from(tocLinks).some((link) => link.getAttribute('href') === window.location.hash)) {
        requestAnimationFrame(() => {
            scrollToTarget(window.location.hash, false);
        });
    }
}

var previousScrollY = 0;
var isScrollLocked = false;
var resizeScrollY = null;
var resizeRestoreRaf = null;
var resizeScrollTimer = null;
var resizeRestoreTimers = [];
var programsResizeProgress = null;
var programsResizeTitle = null;
var lastWindowWidth = typeof window !== "undefined" ? window.innerWidth : 0;
var lastWindowHeight = typeof window !== "undefined" ? window.innerHeight : 0;
// Mobile address/toolbar collapse is well under this; orientation/real reflow is well above.
var ADDRESS_BAR_MAX_DELTA = 160;
var viewportRefreshTimer = null;

// Snap viewport-height-dependent ScrollTriggers (e.g. testimonials scrub) to the
// new position after the mobile address bar collapses/expands, without running the
// scroll-restore loop that fights the scroll.
function refreshViewportDependentTriggers() {
    if (isScrollLocked || typeof ScrollTrigger === "undefined") return;

    if (typeof lenis !== "undefined" && typeof lenis.resize === "function") {
        lenis.resize();
    }

    ["testimonials-scroll", "programs-showcase"].forEach((triggerId) => {
        var trigger = ScrollTrigger.getById(triggerId);
        if (trigger && typeof trigger.refresh === "function") {
            trigger.refresh();
        }
    });
}

function scheduleViewportDependentRefresh() {
    clearTimeout(viewportRefreshTimer);
    viewportRefreshTimer = setTimeout(refreshViewportDependentTriggers, 120);
}

function getCurrentScrollY() {
    if (typeof lenis !== "undefined" && typeof lenis.actualScroll === "number") {
        return Math.round(lenis.actualScroll);
    }

    return Math.round(window.scrollY || document.documentElement.scrollTop || 0);
}

function clampScrollY(scrollY) {
    const root = document.documentElement;
    const maxScrollY = Math.max(0, root.scrollHeight - window.innerHeight);

    return Math.max(0, Math.min(Math.round(scrollY), maxScrollY));
}

function setScrollImmediate(scrollY) {
    const y = clampScrollY(scrollY);

    if (typeof lenis !== "undefined" && typeof lenis.scrollTo === "function") {
        lenis.scrollTo(y, { immediate: true, force: true });
    }

    window.scrollTo(0, y);
}

function refreshScrollTriggersPreservingScroll(scrollY = getCurrentScrollY()) {
    if (typeof lenis !== "undefined" && typeof lenis.resize === "function") {
        lenis.resize();
    }

    ScrollTrigger.refresh();
    setScrollImmediate(scrollY);

    requestAnimationFrame(() => {
        setScrollImmediate(scrollY);
    });
}

function clearResizeRestoreTimers() {
    resizeRestoreTimers.forEach((timer) => {
        clearTimeout(timer);
    });
    resizeRestoreTimers = [];
}

function clearResizeScrollState() {
    clearTimeout(resizeScrollTimer);
    clearResizeRestoreTimers();

    if (resizeRestoreRaf !== null) {
        cancelAnimationFrame(resizeRestoreRaf);
        resizeRestoreRaf = null;
    }

    resizeScrollY = null;
    programsResizeProgress = null;
    releaseProgramsShowcaseResizePin();
}

function keepScrollDuringResize() {
    if (resizeScrollY === null || isScrollLocked) {
        resizeRestoreRaf = null;
        return;
    }

    setScrollImmediate(resizeScrollY);
    resizeRestoreRaf = requestAnimationFrame(keepScrollDuringResize);
}

function holdProgramsShowcaseResizePin(trigger) {
    const title = trigger && trigger.pin;
    const module = title && title.closest(".module--programs");
    if (!title || !module) return;

    const moduleRect = module.getBoundingClientRect();
    const moduleStyle = getComputedStyle(module);
    const paddingLeft = parseFloat(moduleStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(moduleStyle.paddingRight) || 0;

    programsResizeTitle = title;
    title.classList.add("is-width-resizing");
    title.style.setProperty("--programs-resize-top", getSectionDistance() + "px");
    title.style.setProperty("--programs-resize-left", (moduleRect.left + paddingLeft) + "px");
    title.style.setProperty(
        "--programs-resize-width",
        Math.max(0, moduleRect.width - paddingLeft - paddingRight) + "px"
    );
}

function releaseProgramsShowcaseResizePin() {
    if (!programsResizeTitle) return;

    programsResizeTitle.classList.remove("is-width-resizing");
    [
        "--programs-resize-top",
        "--programs-resize-left",
        "--programs-resize-width"
    ].forEach((property) => {
        programsResizeTitle.style.removeProperty(property);
    });
    programsResizeTitle = null;
}

function finishProgramsShowcaseResize() {
    const progress = programsResizeProgress;

    if (progress === null || typeof ScrollTrigger === "undefined") {
        releaseProgramsShowcaseResizePin();
        return;
    }

    releaseProgramsShowcaseResizePin();

    if (typeof lenis !== "undefined" && typeof lenis.resize === "function") {
        lenis.resize();
    }

    ScrollTrigger.refresh();

    const trigger = ScrollTrigger.getById("programs-showcase");
    if (!trigger) {
        programsResizeProgress = null;
        return;
    }

    const scrollY = trigger.start + ((trigger.end - trigger.start) * progress);
    setScrollImmediate(scrollY);
    ScrollTrigger.update();
    programsResizeProgress = null;

    requestAnimationFrame(() => {
        setScrollImmediate(scrollY);
        ScrollTrigger.update();
    });
}

function preserveScrollOnResize() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var widthChanged = width !== lastWindowWidth;
    var heightDelta = Math.abs(height - lastWindowHeight);

    lastWindowWidth = width;
    lastWindowHeight = height;

    // Ignore only the mobile address bar showing/hiding. Applying this exception
    // on desktop also ignored ordinary height-only window resizes and left pins
    // with stale start/end measurements.
    var isMobileToolbarResize = window.matchMedia("(max-width: 991px)").matches
        && !widthChanged
        && heightDelta <= ADDRESS_BAR_MAX_DELTA;

    if (isMobileToolbarResize) {
        // Don't run the scroll-restore loop (it fights the scroll), but still snap
        // viewport-height-dependent modules to their new positions.
        if (heightDelta > 0) scheduleViewportDependentRefresh();
        return;
    }

    if (isScrollLocked) return;

    const programsTrigger = typeof ScrollTrigger !== "undefined"
        ? ScrollTrigger.getById("programs-showcase")
        : null;
    const isResizingActivePrograms = programsResizeProgress !== null
        || (widthChanged && programsTrigger && programsTrigger.isActive);

    if (isResizingActivePrograms) {
        // Repeatedly forcing the same absolute scroll position while the layout is
        // changing makes Lenis, ScrollTrigger and the browser fight each other.
        // Preserve relative progress instead, then refresh and restore once the
        // width resize has settled.
        if (programsResizeProgress === null) {
            programsResizeProgress = programsTrigger.progress;
        }

        clearTimeout(resizeScrollTimer);
        clearResizeRestoreTimers();

        if (resizeRestoreRaf !== null) {
            cancelAnimationFrame(resizeRestoreRaf);
            resizeRestoreRaf = null;
        }

        resizeScrollY = null;
        holdProgramsShowcaseResizePin(programsTrigger);
        resizeScrollTimer = setTimeout(finishProgramsShowcaseResize, 160);
        return;
    }

    if (resizeScrollY === null) {
        const currentScrollY = getCurrentScrollY();
        if (currentScrollY <= 1) {
            // At the top there is no scroll to preserve. Use the same trailing
            // debounce as the scrolled resize path so an interactive height resize
            // cannot leave triggers measured against an intermediate viewport.
            clearTimeout(resizeScrollTimer);
            resizeScrollTimer = setTimeout(() => {
                rafRefreshST();
            }, 160);
            return;
        }

        resizeScrollY = currentScrollY;
    }

    const scrollY = resizeScrollY;

    clearTimeout(resizeScrollTimer);
    clearResizeRestoreTimers();

    setScrollImmediate(scrollY);

    if (resizeRestoreRaf === null) {
        resizeRestoreRaf = requestAnimationFrame(keepScrollDuringResize);
    }

    resizeScrollTimer = setTimeout(() => {
        refreshScrollTriggersPreservingScroll(scrollY);

        resizeRestoreTimers = [
            setTimeout(() => setScrollImmediate(scrollY), 80),
            setTimeout(() => {
                setScrollImmediate(scrollY);
                resizeScrollY = null;
            }, 450),
        ];
    }, 160);
}

   function stopScroll() {
        if (isScrollLocked) {
            return;
        }

        previousScrollY = window.scrollY;
        isScrollLocked = true;

        document.body.classList.add('freeze');

        document.body.style.marginTop = -previousScrollY + 'px';
        ScrollTrigger.refresh();

        lenis.stop();

    }

    function resumeScroll() {
        if (!isScrollLocked) {
            return;
        }

        document.body.classList.remove('freeze');
        document.body.style.marginTop = '0px';
        isScrollLocked = false;

        lenis.start();

        window.scrollTo({
            top: previousScrollY,
            left: 0,
            behavior: 'instant'
        });
        //ScrollTrigger.refresh();
        ScrollTrigger.refresh();
    }

function initDropdown(elem) {
    const containers = document.getElementsByClassName(elem);

    Array.from(containers).forEach((container) => {
        // Get the inner select element
        const selElmnt = container.querySelector("select");
        if (!selElmnt) {
            console.warn("No select element found in container:", container);
            return;
        }

        // Check if the custom elements already exist
        let existingSelected = container.querySelector(".select-selected");
        let existingItems = container.querySelector(".select-items");

        // If they exist, simply exit this iteration
        if (existingSelected && existingItems) {
        return;
        }

        // Create the DIV that will act as the selected item if it doesn't exist
        if (!existingSelected) {
        existingSelected = document.createElement("DIV");
        existingSelected.className = "select-selected";
        existingSelected.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        container.appendChild(existingSelected);
        }

        // Create the DIV that will contain the option list if it doesn't exist
        if (!existingItems) {
        existingItems = document.createElement("DIV");
        existingItems.className = "select-items select-hide";
        Array.from(selElmnt.options).forEach((option, index) => {
            const optionDiv = document.createElement("DIV");
            optionDiv.setAttribute("data-lenis-prevent", "true");
            optionDiv.innerHTML = option.innerHTML;
            if (index === selElmnt.selectedIndex) {
            optionDiv.className = "same-as-selected";
            }
            optionDiv.addEventListener("click", function(e) {
            const s = this.parentNode.parentNode.querySelector("select");
            const h = this.parentNode.previousSibling;
            Array.from(s.options).forEach((opt, i) => {
                if (opt.innerHTML === this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                // Remove highlight from previously selected items
                const highlighted = this.parentNode.getElementsByClassName("same-as-selected");
                Array.from(highlighted).forEach(el => el.classList.remove("same-as-selected"));
                this.className = "same-as-selected";
                
                // Trigger change event on the original select
                const event = new Event('change', { bubbles: true });
                s.dispatchEvent(event);
                }
            });
            h.click(); // Close the dropdown
            });
            existingItems.appendChild(optionDiv);
        });
        container.appendChild(existingItems);
        }

        // Event listener for the custom select element
        existingSelected.addEventListener("click", function(e) {
            e.stopPropagation();
            closeAllSelect(this);
            existingItems.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    });
}

function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document, except the current select box: */
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i);
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

function getVibes(){
    filters = $('.filters');
    if (filters.length) {
        var vibes = filters.find('.tag');
         if (vibes.length) {
            ids = [];

            vibes.each(function () {
                if ($(this).hasClass('active')) {
                    var id = $(this).data('id');
                    if (id !== undefined) {
                        ids.push(id);
                    }
                }
            });
        }
    }

    return ids;
}

function getLocations(){
    ids = [];
    var location = $('.location-select');
    if(location.length){
        var id = location.val();
        ids.push(id);
    }
    return ids;
}

function programFilters(tagIds, locationIds){
    $.ajax({
        url: icon_ajax.ajaxurl,
        method: 'POST',
        data: {
            action: 'icon_ajax_filters',
            // Keep WPML in the page language even when consent blocks its cookie.
            lang: icon_ajax.lang,
            vibes: tagIds,
            locations: locationIds
        },
        success: function (response) {
            if (response.success) {
                    $('.dynamic-row').html(response.data.html);
            } else {
                $('.dynamic-row').html('<p>No results found.</p>');
            }
        },
        error: function (xhr, status, error) {
            //console.log(error);
        }
    });
}

let rafRefreshPending = false;
function rafRefreshST() {
  if (rafRefreshPending) return;
  rafRefreshPending = true;
  const scrollY = getCurrentScrollY();
  // 2 rAFs is more reliable when layout needs an extra tick
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      rafRefreshPending = false;
      refreshScrollTriggersPreservingScroll(scrollY);
    });
  });
}

function refreshOnMedia(container) {
  if (!container) return;

  const media = container.querySelectorAll('img, video');
  if (!media.length) {
    rafRefreshST();
    return;
  }

  media.forEach((el) => {
    if (el.tagName === 'IMG') {
      if (el.complete) return;
      el.addEventListener('load', rafRefreshST, { once: true });
      el.addEventListener('error', rafRefreshST, { once: true });
      return;
    }

    // Skip lazy videos (data-src) until they get a real source
    const hasSource = el.currentSrc || el.src || el.querySelector('source');
    if (!hasSource || el.readyState >= 1) return;
    el.addEventListener('loadedmetadata', rafRefreshST, { once: true });
    el.addEventListener('error', rafRefreshST, { once: true });
  });

  // Fonts can shift layout after load
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(rafRefreshST).catch(() => {});
  }
}

function observeParallaxResize(container) {
  if (!container || !('ResizeObserver' in window)) return;
  if (container.__parallaxResizeObserver) return;

  const ro = new ResizeObserver(() => {
    rafRefreshST();
  });
  ro.observe(container);
  container.__parallaxResizeObserver = ro;
}

// Pins whose `start` depends on the content ABOVE them (e.g. .module--programs)
// drift when lazy-loaded media further up the page finishes and grows the page
// height. ScrollTrigger only recomputes `start` on refresh, so watch the overall
// document height and refresh (scroll-preserving) whenever it changes.
//
// The content above the module only loads during the initial page settle, so this
// observer is debounced, ignores sub-threshold noise, and auto-disconnects shortly
// after load — otherwise it would keep firing full refreshes while scrolling (lazy
// media below loading, mobile address bar, etc.) and cause scroll lag.
function observeDocumentHeightForRefresh() {
  if (!('ResizeObserver' in window)) return;
  if (document.body.__documentHeightObserver) return;

  const HEIGHT_DELTA_THRESHOLD = 4;
  const DEBOUNCE_MS = 200;
  const AUTO_DISCONNECT_MS = 4000;

  let lastHeight = document.documentElement.scrollHeight;
  let debounceTimer = null;
  let disconnectTimer = null;

  const stop = () => {
    clearTimeout(debounceTimer);
    clearTimeout(disconnectTimer);
    ro.disconnect();
    document.body.__documentHeightObserver = null;
  };

  const ro = new ResizeObserver(() => {
    const height = document.documentElement.scrollHeight;
    if (Math.abs(height - lastHeight) < HEIGHT_DELTA_THRESHOLD) return;
    lastHeight = height;

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(rafRefreshST, DEBOUNCE_MS);
  });

  ro.observe(document.body);
  document.body.__documentHeightObserver = ro;

  // Stop watching once the page has settled after load.
  const scheduleDisconnect = () => {
    disconnectTimer = setTimeout(stop, AUTO_DISCONNECT_MS);
  };
  if (document.readyState === 'complete') {
    scheduleDisconnect();
  } else {
    window.addEventListener('load', scheduleDisconnect, { once: true });
  }
}

function bindWindowStateRefresh() {
  // Maximize/restore/resize

  // "Minimize/tab out" -> refresh when coming back
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) rafRefreshST();
  });

  // Some browsers resume without visibilitychange; focus is a nice extra net
  window.addEventListener("focus", rafRefreshST);

  // Back/forward cache restore
  window.addEventListener("pageshow", rafRefreshST);
}
